import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import moment from "moment";
import EmptyData from "../../../components/EmptyData";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";

export default function EmpReservationsTable({ reservations }) {
  const navigate = useHistory();

  return (
    <div className="table-rep-plugin">
      <div className="table-responsive">
        <Table className="table table-striped table-bordered">
          <Thead className="table-light table-nowrap">
            <Tr>
              <Th>Start</Th>
              <Th>End</Th>
              <Th>Room</Th>
              <Th>Car</Th>
            </Tr>
          </Thead>

          {reservations.length > 0 && (
            <Tbody>
              {reservations
                .filter((r) => r.room_id || r.car_id)
                .map((row) => {
                  return (
                    <Tr key={row.id}>
                      <Td>
                        {row.startAt &&
                          moment(row.startAt).format("DD MMM YYYY")}
                      </Td>
                      <Td>
                        {row.endAt && moment(row.endAt).format("DD MMM YYYY")}
                      </Td>
                      <Td>
                        {row.room_id && (
                          <Button
                            color="dark"
                            size="sm"
                            onClick={() =>
                              navigate.push(`/room-renters/${row.room.id}`)
                            }
                          >
                            View
                          </Button>
                        )}
                      </Td>
                      <Td>
                        {row.car_id && (
                          <Button
                            color="dark"
                            size="sm"
                            onClick={() =>
                              navigate.push(`/car-renters/${row.car.id}`)
                            }
                          >
                            View
                          </Button>
                        )}
                      </Td>
                    </Tr>
                  );
                })}
            </Tbody>
          )}
        </Table>

        <EmptyData
          empty={reservations.length === 0}
          msg="No Reservations Found."
        />
      </div>
    </div>
  );
}
